import { useButton } from 'react-aria';

import styles from './PopoverButton.module.scss';

const PopoverButton = (props) => {
    const ref = props.buttonRef;
    const { buttonProps } = useButton({
        ...props,
        elementType: 'span'
    }, ref);

    const { isOpen } = props;

    return (

        <span
            {...buttonProps}
            ref={ref}
            className={[
                styles.button,
                isOpen ? styles.focus : null
            ].join(' ')}
        >
            {props.children}
        </span>
    );
};

export default PopoverButton;
